import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function CTASection() {
  const { isRegistered, openRegisterModal } = useAuth();

  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=massive%20packed%20football%20stadium%20at%20night%20with%20dramatic%20floodlights%20smoke%20effects%20crowd%20atmosphere%20epic%20cinematic%20moment%20championship%20final%20dark%20dramatic%20sky%20vibrant%20energy&width=1440&height=600&seq=cta1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0d0f14]/80"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0d0f14] via-transparent to-[#0d0f14]"></div>
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 text-center">
        <h2 className="text-white text-5xl md:text-7xl font-black uppercase tracking-tight mb-6 leading-none">
          ÚNETE A <span className="text-[#00e87a]">50.000+</span><br />
          APOSTADORES INTELIGENTES
        </h2>
        <p className="text-white/70 text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
          Accede gratis a estadísticas básicas y el foro.<br />
          Desbloquea análisis avanzados, alertas y ligas privadas con <strong className="text-white">Premium</strong>.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          {isRegistered ? (
            <Link
              to="/estadisticas"
              className="group relative flex items-center gap-3 px-8 py-4 bg-black border border-white/20 text-white font-black rounded-full hover:border-[#00e87a]/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span className="absolute left-2 flex items-center justify-center w-9 h-9 bg-[#00e87a] rounded-full transition-colors duration-300">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-rocket-line text-black text-sm"></i>
                </div>
              </span>
              <span className="pl-8 text-base uppercase tracking-wide">IR AL DASHBOARD</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-lg text-[#00e87a]"></i>
              </div>
            </Link>
          ) : (
            <button
              onClick={openRegisterModal}
              className="group relative flex items-center gap-3 px-8 py-4 bg-black border border-white/20 text-white font-black rounded-full hover:border-[#00e87a]/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span className="absolute left-2 flex items-center justify-center w-9 h-9 bg-[#ff6b35] rounded-full group-hover:bg-[#00e87a] transition-colors duration-300">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-rocket-line text-white text-sm"></i>
                </div>
              </span>
              <span className="pl-8 text-base uppercase tracking-wide">CREAR CUENTA GRATIS</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-lg text-[#00e87a]"></i>
              </div>
            </button>
          )}

          <Link
            to="/ranking"
            className="flex items-center gap-2 px-8 py-4 text-[#a8b2c1] font-semibold hover:text-white transition-colors whitespace-nowrap cursor-pointer text-base"
          >
            <span>Ver tipsters verificados</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-external-link-line"></i>
            </div>
          </Link>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-8 text-[#6b7280] text-sm">
          {[
            { icon: 'ri-shield-check-line', label: 'Datos verificados' },
            { icon: 'ri-lock-line', label: 'Sin tarjeta de crédito' },
            { icon: 'ri-award-line', label: 'Licencias DGOJ' },
            { icon: 'ri-customer-service-line', label: 'Soporte 24/7' },
          ].map((badge) => (
            <div key={badge.label} className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center text-[#00e87a]">
                <i className={`${badge.icon} text-base`}></i>
              </div>
              <span>{badge.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
